import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { HttpMethods, SERVICES } from '../../services/api';
import apiAsyncThunkCreator from '../../services/apiAsyncThunkCreator';
import { IAccount } from './account';
import { ThunkAPI } from '../rootReducer';
import { Ifilter } from '../../components/common/filters/interfaces';
import { buildQueryParams, ListParams } from '../utils';

export const fetchAccountsListToExport:AsyncThunk<{ accounts: IAccount[] }, ListParams<Ifilter[]>, ThunkAPI> = createAsyncThunk(
  'accounts/fetchAccountsListToExport',
  (searchParams: ListParams<Ifilter[]>, thunk) => {
    return apiAsyncThunkCreator<{ accounts: IAccount[] }, void>({
      endpoint: `accounts/${buildQueryParams(searchParams)}`,
      microservice: SERVICES.USERS_SERVICE,
      authenticated: true,
      method: HttpMethods.Get
    })(undefined, thunk);
  }
);
